import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { insertElementsToHTMLBanner } from './insertElementsToHTMLBanner';
export function useHTMLBannerInserts(_ref) {
  let {
    eventEmitter,
    containerId
  } = _ref;
  useIsomorphicLayoutEffect(() => {
    let removeElementsFromHTMLBanner = null;
    let adFoxBannerOnLoadData = null;
    const unsubscribe = eventEmitter.subscribe(data => {
      var _adFoxBannerOnLoadDat;
      switch (data.event) {
        case 'load':
          adFoxBannerOnLoadData = data.data;
          break;
        case 'render':
          if ((_adFoxBannerOnLoadDat = adFoxBannerOnLoadData) !== null && _adFoxBannerOnLoadDat !== void 0 && _adFoxBannerOnLoadDat.bundleParams && adFoxBannerOnLoadData.bundleName === 'banner.interscroller') {
            removeElementsFromHTMLBanner = insertElementsToHTMLBanner(adFoxBannerOnLoadData.bundleParams, containerId);
          }
          unsubscribe();
          break;
        case 'stub':
        case 'error':
          unsubscribe();
          break;
      }
    });
    return () => {
      var _removeElementsFromHT;
      (_removeElementsFromHT = removeElementsFromHTMLBanner) === null || _removeElementsFromHT === void 0 || _removeElementsFromHT();
      unsubscribe();
    };
  }, []);
}